import styled from 'styled-components';
import { DropdownIcon } from '../assets';
import Button from '../button/Button';
import Typography from '../typography/Typography';
export const PageWrapper = styled.div `
  padding-top: 1rem;
`;
export const BankWireCheckPointsContainer = styled.div `
  background-color: ${({ theme }) => theme.colors.interactive.secondary};
  overflow-x: auto;
  width: 100%;
  height: 11.4rem;
  &::-webkit-scrollbar {
    display: none;
  }
  span {
    line-height: 2rem;
  }

  margin-top: 1.6rem;
  border-top: 1px solid ${({ theme }) => theme.colors.borders.default};
  border-bottom: 1px solid ${({ theme }) => theme.colors.borders.default};

  display: flex;
  flex-direction: row;
  padding: 1.6rem 2.4rem;
  ${({ theme, containerWidth }) => {
    const borderRadius = theme.borderRadius.high;
    return theme.media.tablet `
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: ${containerWidth};
  height: 63rem;
  border-radius: ${borderRadius};
  &::-webkit-scrollbar {
    display: none;
  }
  padding 3.9rem 3.9rem 4rem;
  `;
}};
`;
export const StepsWrapper = styled.div `
  display: flex;
  flex-direction: column-reverse;
  ${({ theme }) => theme.media.tablet `
     display: flex;
     flex-direction: row;
     justify-content: space-between;
  `}
`;
export const BankWireCheckPoints = styled.div `
  display: flex;
  align-items: center;
  width: min-content;
  ${({ theme }) => theme.media.tablet `
  display: flex;
  flex-direction: column;
  `}
`;
export const CheckPoint = styled.div `
  width: 1.8rem;
  height: 1.8rem;
  background-color: ${({ backgroundColor }) => backgroundColor};
  border: 3px solid ${({ borderColor }) => borderColor};
  border-radius: ${({ theme }) => theme.borderRadius.high};
  cursor: pointer;
`;
export const CheckPointFirstLine = styled.div `
  background-color: ${({ backgroundColor }) => backgroundColor};
  width: 10.7rem;
  height: 0.1rem;
  ${({ theme }) => theme.media.tablet `
    transform: none; 
    margin-left: 0rem;
    width: 0.1rem;
    height: 6rem;
  `};
`;
export const Gradient = styled.div `
  display: none;
  pointer-events: none;
  ${({ theme, lastStep }) => {
    const display = lastStep ? 'none' : 'block';
    return theme.media.tablet `
    display: ${display};
    width: 100%;
    height: 10.2rem;
    position: absolute;
    bottom: 0.5rem;
    left: 0;
    right: 0;
    border-radius: 14px;
    // NOTE: when it is gradient we cant add colors from library
    background: linear-gradient(
        180deg,
         rgba(235, 241, 255, 0.17) 0%,
         rgba(229, 237, 255, 0.8) 50%,
         #dfe8fd 100%
       );
    `;
}}
`;
export const GradientTop = styled.div `
  display: none;
  pointer-events: none;
  ${({ theme, firstStep }) => {
    const display = firstStep ? 'none' : 'block';
    return theme.media.tablet `
    display: ${display};
    width: 100%;
    height: 10.2rem;
    position: absolute;
    top: 1.5rem;
    left: 0;
    right: 0;
    border-radius: 14px;
    transform: rotate(180deg);
    // NOTE: when it is gradient we cant add colors from library
    background: linear-gradient(
        180deg,
         rgba(235, 241, 255, 0.17) 0%,
         rgba(229, 237, 255, 0.8) 50%,
         #dfe8fd 100%
       );
    `;
}}
`;
export const MobileGradient = styled.div `
  pointer-events: none;
  display: ${({ firstStep }) => (firstStep ? 'none' : 'block')};
  width: 11.4rem;
  height: 11.4rem;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(
    180deg,
    rgba(235, 241, 255, 0.17) 0%,
    rgba(229, 237, 255, 0.8) 50%,
    #dfe8fd 100%
  );
  transform: rotate(90deg);
  flex-shrink: 0;

  ${({ theme }) => theme.media.tablet `
    display: none;
  `}
`;
export const MobileGradientRight = styled.div `
  pointer-events: none;
  display: ${({ lastStep }) => (lastStep ? 'none' : 'block')};
  width: 11.4rem;
  height: 11.4rem;
  position: absolute;
  bottom: 0;
  right: 0;
  background: linear-gradient(
    180deg,
    rgba(235, 241, 255, 0.17) 0%,
    rgba(229, 237, 255, 0.8) 50%,
    #dfe8fd 100%
  );
  transform: rotate(-90deg);
  flex-shrink: 0;
  ${({ theme }) => theme.media.tablet `
    display: none;
  `}
`;
export const FaqSteps = styled.div `
  display: flex;

  ${({ theme }) => theme.media.tablet `
    flex-direction: column;
  `};
`;
export const CheckPointTitleWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 0rem;

  &:last-child {
    ${CheckPointFirstLine} {
      display: none;
    }
  }
  ${({ theme }) => theme.media.tablet `
    display: flex;
    flex-direction: row;
    gap: 1rem;
  `}
`;
export const TitleWrapper = styled.div `
  display: flex;
  gap: 1rem;
  margin-top: 0.8rem;
  cursor: pointer;
  ${({ theme }) => theme.media.tablet `
    margin-top: 0;
  `}
`;
export const BankWireImagesContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 5rem;
`;
export const BankWireImage = styled.div `
  margin-top: 1rem;
  margin-left: 8rem;
  border-radius: 3rem;
  width: 21.6rem;
  height: 45.8rem;
  background-size: cover;
  background-image: url(${({ currentImage }) => currentImage});
  background-repeat: no-repeat;

  ${({ theme }) => theme.media.tablet `
    margin-top: 1.1rem;
    margin-left: 9rem;
    border-radius: 3rem;
    width: 23.4rem;
    height: 50.4rem;
  `}
`;
export const BankWireImageContainer = styled.div `
  width: fit-content;
  position: absolute;
  top: -11rem;
  margin-right: 1rem;
  width: 35rem;
  height: 51rem;
  background-size: cover;

  background-image: url(${({ MobileFrameImage }) => MobileFrameImage});

  ${({ theme }) => theme.media.tablet `
    top: -12rem;
    width: 40rem;
    height: 56rem;
  `};
`;
export const ButtonWrapper = styled.div `
  align-self: center;
  display: flex;
  gap: 1.7rem;
  margin-top: 2rem;
`;
export const CustomButton = styled(Button) `
  width: 4.8rem;
  height: 5rem;
`;
export const CheckPointsContainerWrapper = styled.div `
  position: relative;
`;
export const CustomTitleTypography = styled(Typography) `
  margin-left: 3.9rem;
  font-weight: 500;
  ${({ theme }) => theme.media.tablet `
   margin-left: 0;
  `}
`;
export const StepsTitleTypography = styled(Typography) `
  font-size: 1.4rem;
  ${({ theme }) => theme.media.tablet `
    font-size: 1.6rem;
  `}
`;
export const BankWireImageWrapper = styled.div `
  position: relative;
  width: ${({ imageBackgroundWidth }) => imageBackgroundWidth ? imageBackgroundWidth : '31rem'};
  height: 41rem;
  margin-top: 8rem;
  margin-bottom: 1rem;
  background-color: ${({ theme }) => theme.colors.interactive.brandColor};
  display: flex;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.highM};

  ${({ theme, containerWidth }) => theme.media.tablet `
    margin-top: 4rem;
    width: ${containerWidth};
    height: 46rem;
  `}
`;
export const CustomArrowIcon = styled(DropdownIcon) `
  transform: ${({ leftIcon }) => leftIcon ? 'rotate(90deg)' : 'rotate(-90deg)'};
`;
//# sourceMappingURL=styles.js.map